import { useState } from 'react'
import { Delete_Customer } from '@graphql/mutations'
import { useApi } from '@hooks/useApi'

const useDeleteCustomer = () => {
    const [isPosting, setIsPosting] = useState(false)
    const { postMutation } = useApi()

    const post = async (data, successMessage, errorMessage) => {
        setIsPosting(true)

        const res = await postMutation(
            data,
            Delete_Customer,
            successMessage ? successMessage : 'Användaren är raderad.',
            errorMessage ? errorMessage : 'Nåt gick fel när användaren skulle raderas.',
        )

        setIsPosting(false)
        return res
    }

    return {
        post,
        isPosting,
    }
}

export { useDeleteCustomer }
